import { DocumentData } from "firebase/firestore";
import { add, cumsum, divide, multiply, round, sum } from "mathjs";

type Props = {
  states: DocumentData[];
  ratio: number[];
  remins: number[];
  counts: number[];
};

export const calcByItemForPlansInputMonthly = ({
  states,
  ratio,
  remins,
  counts,
}: Props) => {
  const byItem: number[][] = [];
  const byItemCumsum: number[][] = [];
  const monthlyTotalByItem: number[] = [];
  let monthlyTotal: number[] = [];
  let monthlyData: number[] = [0];
  states.map((state, stateIndex) => {
    const itemData: number[] = [];
    counts.map((count, countIndex) => {
      const data =
        state.section === "変動"
          ? multiply(remins[stateIndex], ratio[countIndex])
          : (divide(
              remins[stateIndex],
              round(divide(counts.length, sum(counts)))
            ) as number);
      itemData.push(data);
    });
    if (stateIndex === 0) {
      monthlyData = itemData;
    } else {
      monthlyData = add(monthlyData, itemData);
    }
    byItem.push(itemData);
    byItemCumsum.push(cumsum(itemData) as number[]);
    monthlyTotalByItem.push(sum(itemData) as number);
    if (states.length === stateIndex + 1) {
      monthlyTotal = monthlyData;
    }
  });
  const monthlyTotalCumsum = cumsum(monthlyTotal) as number[];

  return {
    byItem,
    monthlyTotal,
    monthlyTotalByItem,
    byItemCumsum,
    monthlyTotalCumsum,
  };
};
